import ViewComplaintTracking from 'components/viewComplaintTracking/ViewComplaintTracking.component';

const ViewComplaintTrackingPage = () => {
	return <ViewComplaintTracking />;
};

export default ViewComplaintTrackingPage;
